import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import {useEffect, useState} from "react";
import {apiClient} from "../../AxiosConfig";
import UserStore from "../../store/user-store";

const fetchUserData = async (initDataBs64, ref_code = null) => {
    const data = {}

    if (ref_code) {
        data.referral_code = ref_code
    }
    const response = await axios.post(`${process.env.REACT_APP_API_URL}/v1/user/`, data,{
        headers: {
            Authorization: `Bearer ${initDataBs64}`,
        },
        withCredentials: true // Enable sending/receiving cookies
    });

    if ((response.status === 200 || response.status === 201) && response.data.detail !== "User not found") {
        return response;
    }
    if ((response.status === 200 || response.status === 201) && response.data.detail === "User not found") {
        // Create new user and return that response directly
        return await axios.post(`${process.env.REACT_APP_API_URL}/v1/user/create`, {},{
            headers: {
                Authorization: `Bearer ${initDataBs64}`,
            },
            withCredentials: true
        });
    }
    throw new Error(`Failed to fetch user data: ${response.status}`);
};


const fetchUserPlans = async () => {
    const response = await apiClient(`${process.env.REACT_APP_API_URL}/v1/plans/`)

    if ((response.status === 200 || response.status === 201) && response.data.detail !== "User not found") {
        return response;
    }
}

export const useFetchUser = (initData, ref_code = null) => {
    const initDataBs64 = btoa(initData)
    const [isLoadingAll, setIsLoading] = useState(true);

    if (ref_code && ref_code.includes("ref_code"))
        ref_code = ref_code.replace("ref_code=", "")
    const { data, isLoading, isSuccess } = useQuery({
        queryKey: ['user'],
        queryFn: () => fetchUserData(initDataBs64, ref_code),
        enabled: Boolean(initData),
        retry: 0
    });


    if (data) {
        const authToken = data.headers['x-auth-token'];
        UserStore.setUserData(data.data, authToken);
    }

    useEffect(() => {
        if (!isLoading && isSuccess) {
            fetchUserPlans().then(data => {
                UserStore.setUserPlanData(data.data)
                setIsLoading(false)
            })
        }
    }, [isSuccess])

    return { data, isLoadingAll };
};
